import React from "react";

import { Typography, Grid } from "@mui/material";

import {
  GradientLineBox,
  FeatureCard,
  FeaturesContainer,
  FeatureCardContainer,
} from "./styles";

import { features } from "../data/home";

const Features = () => {
  return (
    <FeaturesContainer>
      <FeatureCardContainer container spacing={3} sx={{ marginTop: -12 }}>
        {features.map((feature) => {
          return (
            <Grid
              item
              xs={12}
              lg={4}
              key={feature.title}
              sx={{ maxWidth: 415 }}
            >
              <GradientLineBox className="fade-in">
                <FeatureCard>
                  <img
                    src={feature.img}
                    alt={feature.title}
                    style={imgStyles}
                  />
                  <Typography
                    variant="h4"
                    color="primary"
                    className="text-glow-primary"
                    sx={{ margin: "12px 0" }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography sx={{ maxWidth: 300 }}>{feature.copy}</Typography>
                </FeatureCard>
              </GradientLineBox>
            </Grid>
          );
        })}
      </FeatureCardContainer>
    </FeaturesContainer>
  );
};

export default Features;

const imgStyles = {
  height: 100,
};
